export const cmsUrl = process.env.VUE_APP_CMS_URL;
export const consultingApiUrl = process.env.VUE_APP_CONSULTING_API_URL;
export const consultingApiKey = process.env.VUE_APP_CONSULTING_API_KEY